<script>
import baseMixin from '@/mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UpdateEmailDialogAndButton',
  mixins: [baseMixin],
  props: {
    candidateId: {
      type: Number,
      required: true,
    },
    candidateName: {
      type: String,
      required: true,
    },
    candidateEmail: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapGetters({
      isLoadingCandidateUserDetailsCRUD:
        'candidate/isLoadingCandidateUserDetailsCRUD',
    }),
  },
  methods: {
    ...mapActions({ syncLoginEmail: 'candidate/syncLoginEmail' }),
    async handleUpdateEmail() {
      const response = await this.syncLoginEmail(this.candidateId)

      if (!response.isSuccess) return

      this.$emit('login-email-synchronised')

      this.dialog = false
    },
  },
}
</script>

<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        id="update-login-email-button"
        color="primary"
        v-bind="attrs"
        v-on="on"
        >{{ $t('candidate.updateEmailBtnLabel') }}</v-btn
      >
    </template>
    <v-card id="update-login-email-dialog-card" tile class="overflow-x-hidden">
      <h6 class="text-h6">{{ $t('candidate.updateLoginEmailTitle') }}</h6>
      <p class="text-body-2"
        >{{ $t('candidate.updateLoginDialogPrompt', { candidateName }) }}
        <strong>{{ candidateEmail }}</strong
        >.</p
      >
      <section class="d-flex justify-end">
        <v-btn
          color="primary"
          text
          :disabled="isLoadingCandidateUserDetailsCRUD"
          @click="dialog = false"
        >
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn
          id="confirm-button"
          color="primary"
          :loading="isLoadingCandidateUserDetailsCRUD"
          @click="handleUpdateEmail"
        >
          {{ $t('general.confirm') }}
        </v-btn>
      </section>
    </v-card>
  </v-dialog>
</template>
